$(document).ready(function() {
 

    // Slideshow
    $('.owl-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1
    });

        // Home Category
    $('.owl-catt').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1410,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        }
        ]
    });
  	$(".owl-catt").show();

    // // Special Product    
    $('.owl-catt2').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });
    $(".owl-catt2").show();

    // Special Product    
    $('.wbspeprod').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        }
        ]
    });
    $(".wbspeprod").show();


    // Countdown Timer
    $('[data-countdown]').each(function() {
        var $this = $(this), finalDate = $(this).data('countdown');
        Date.prototype.yyyymmdd = function() {
            var yyyy = this.getFullYear().toString();
            var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
            var dd  = this.getDate().toString();
            return yyyy + "/" + (mm[1]?mm:"0"+mm[0]) + "/" + (dd[1]?dd:"0"+dd[0]); // padding
        };
        var date = new Date();
        if (finalDate > date.yyyymmdd()){
            $(this).parents('.timer_outer').css('display','block');
        }else{
            $(this).parents('.timer_outer').css('display','none');  
        }
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<span>%D</span><span>%H</span><span>%M</span><span>%S</span>'));
        });
    });


    // Home Tab Product   
    $('.owl-toppro,.wbtopr').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        }
        ]
    });
  	$(".owl-toppro").show();
  	$(".wbtopr").show();

    


    // Product Category
    $(".ptabbr").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: true ,
    autoplaySpeed: 5000, 
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
       {
        breakpoint: 1410,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3
        }
      }
    ]
    });
    $(".ptabbr").show();
    $('.ptabbr a.nav-link').click(function () {
        $('.ptabbr a.nav-link').addClass('active');
        $('.ptabbr a.nav-link').removeClass('active');
    });


    $('.owl-procat').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });
    $(".owl-procat").show();

    // Testimonial
    $('.testi').slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });
  	$(".testi").show();


    // Product Category Bottom
    if ($(window).width() >= 768) {
        $(".ptabbr1").slick({
        rows: 9,
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: false ,
        autoplaySpeed: 5000, 
        slidesToShow: 1,
        slidesToScroll: 1
        });
    }
    $(".ptabbr1").show();
    $('.ptabbr1 a.nav-link').click(function () {
        $('.ptabbr1 a.nav-link').addClass('active');
        $('.ptabbr1 a.nav-link').removeClass('active');
    });

    $('.owl-procat1').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        }
        ]
    });
    $(".owl-procat1").show();

    // Blog
    // $('.wbblog').slick({
    //     dots: false,
    //     arrows: true,
    //     autoplay: false,
    //     autoplaySpeed: 2000,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     responsive: [
    //     {
    //         breakpoint: 1200,
    //         settings: {
    //             slidesToShow: 2
    //         }
    //     },
    //     {
    //         breakpoint: 992,
    //         settings: {
    //             slidesToShow: 2
    //         }
    //     },
    //     {
    //         breakpoint: 768,
    //         settings: {
    //             slidesToShow: 2
    //         }
    //     },
    //     {
    //         breakpoint: 576,
    //         settings: {
    //             slidesToShow: 1
    //         }
    //     }
    //     ]
    // });
  	// $(".wbblog").show();
    
 if ($('.wbblog').hasClass('slick-initialized')) {
    $('.wbblog').slick('unslick');
}
    // Logo Slider
    $('.wblogobar').slick({
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 1410,
            settings: {
                slidesToShow: 7
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 3
            }
        }
        ]
    });
  	$(".wblogobar").show();
  
  	// Home Page Product Tab
    $(".nav-tabs .nav-link.active").click();

$(document).on('click', '.nav-tabs .nav-link', function(e) {
    e.preventDefault();

    // Remove active from all
    $(".nav-tabs .nav-link").removeClass('active');

    // Add active to clicked tab
    $(this).addClass('active');

    let tid = $(this).attr('href');

    // Hide all tab content
    $('.tab-pane').removeClass('active show');

    // Show selected tab
    $(tid).addClass('active show');
});
                                                 
    // Home Page Product Category Tab             
    $(".nav-tabs .nav-item1.active").click();
    $(document).on('click', '.nav-tabs .nav-item1', function(e) {
        e.preventDefault();
        $(".nav-tabs .nav-item1").removeClass('active');
        $(this).addClass('active');
        let tid=  $(this).find('a').attr('href');
        $('.tab-pane1').removeClass('active show');                             
        $(tid).addClass('active show');                            
    });
  
  	// Home Page Product Category Tab             
    $(".nav-tabs .nav-item2.active").click();
    $(document).on('click', '.nav-tabs .nav-item2', function(e) {
        e.preventDefault();
        $(".nav-tabs .nav-item2").removeClass('active');
        $(this).addClass('active');
        let tid=  $(this).find('a').attr('href');
        $('.tab-pane2').removeClass('active show');                             
        $(tid).addClass('active show');                            
    });

    // Scroll To top
    $("#scroll").addClass("scrollhide");
        $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
            $("#scroll").addClass("scrollhide")
        } else {
            $("#scroll").removeClass("scrollhide")
        }
    });
    $('#scroll').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

    // Mobile Menu Toggle
    if ($(window).width() <= 991) {
        $('.wbmegamainhd').on('click', function() {
            var targetMenu = '#' + $(this).data('submenu');
            $(targetMenu).slideToggle(300);
            $(this).toggleClass('active');
            return false;
        });
        // $('#megamenu').prependTo('.headlogo');
    };
    // if ($(window).width() <= 767) {
    //     $('localization-form').appendTo('.customer_account ul');
    // };


    // Collection Grid/List View
    $(document).on('click', '.wblistgridbtn', function(e) {
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('listv')) {
            $('#product-grid').addClass('product-list').removeClass('product-grid');
        } else if ($(this).hasClass('gridv')) {
            $('#product-grid').addClass('product-grid').removeClass('product-list');
        }
    });


    // Popup Product
    $('.wbpopup-popducts .popinner').hide();
    var i = 0;
    setIntervalFun();
    var totalTimer = parseInt(3000) + parseInt(2000);
    setInterval( setIntervalFun, totalTimer);
    function setIntervalFun()
    {
        $('.wbpopup-popducts .popinner').eq(i).fadeIn(400);
        setTimeout(function(){
            $('.wbpopup-popducts .popinner').eq(i).fadeOut(400);
            i++;
            if ($('.wbpopup-popducts .popinner').length <= i) {
                i = 0;
            }
        },parseInt(7000));
    }
    $(document).on('click', '.wbclosepopup', function(){
        $('.wbpopup-popducts').fadeOut(400).remove();
    });


    // Box Layout
    $(".wbboxdemo").click(function(){
        $(".wbboxlt").attr("id","wbboxlayout");
    });
    $(".wbwidedemo").click(function(){
        $(".wbboxlt").removeAttr("id");
    }); 
    // Color Customizer
    $("body").on("click", ".wbinnerclr a", function(e){
    e.preventDefault();
    $('.wbinnerclr').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbcolorname=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbcolorname href="' + $(this).attr('href') + '">');
    });
    // Rtl Mode
    $("body").on("click", ".wbrtlmode a", function(e){ 
    e.preventDefault();
    $('.wbrtlmode').find(".active").removeClass("active");
    $(this).parent().addClass("active");
    $('[wbrtl=""]').remove();
    if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbrtl href="' + $(this).attr('href') + '">');
    });
    // Color Open/Close 
    $('.wbopen-closeclr').click(function() {
        if ($(this).hasClass('wbclrdisable')) {
            $(this).removeClass('wbclrdisable');
            $(this).addClass('wbclrenable');
            $('.wbcolor_box').animate({right: '30px'}, 450);
            $('.wbcolor_box').css({'box-shadow': '0 10px 35px 10px rgba(0,0,0,.06)', 'background': '#fff', 'border-radius': '4px 0 4px 4px'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '1'}, 450);
        } else {
            $(this).removeClass('wbclrenable');
            $(this).addClass('wbclrdisable');
            $('.wbcolor_box').animate({right: '-250px'}, 450);
            $('.wbcolor_box').css({'box-shadow': 'none', 'background': 'transparent'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '0'}, 450);
        }
    });


}); // Document Ready Div End


$(window).on('load',function(){
    $(".s-panel .loader").removeClass("wrloader");
});

// Menu For Mobile
function w3_open() {
    document.getElementById("myOverlay").style.display = "block";
    document.getElementById("megamenu").className = "active";
    $('body').addClass("wbbodyscroll");
}
function w3_close() {
    document.getElementById("myOverlay").style.display = "none";
    document.getElementById("megamenu").className = "";
    $('body').removeClass("wbbodyscroll");
}

  function toggleFAQ(button) {
    const answer = button.nextElementSibling;
    answer.classList.toggle('open');
    button.classList.toggle('active');
  }


function toggleRecipe(element) {
  const content = element.nextElementSibling;
  const icons = element.querySelector(".toggle-icon");

  content.classList.toggle("active");
  icons.classList.toggle("rotate");

  if (content.classList.contains("active")) {
    content.style.display = "block";
  } else {
    content.style.display = "none";
  }
}


 
function toggleRecipee(el) {
  const wrapper = el.parentElement;

  const allWrappers = document.querySelectorAll(
    ".product__ingredients-wrapper, .product__description-wrapper"
  );

  allWrappers.forEach((item) => {
    const content = item.querySelector(
      ".recipe-content, .product__description"
    );

    const icon = item.querySelector(".toggle-icon");

    if (item === wrapper) {
      const isOpen = content.classList.contains("active");

      if (isOpen) {
        content.classList.remove("active");
        content.style.display = "none";

        icon.classList.remove("rotate");
      } else {
        content.classList.add("active");
        content.style.display = "block";

        icon.classList.add("rotate");
      }
    } else {
      content.classList.remove("active");
      content.style.display = "none";

      icon.classList.remove("rotate");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const allContents = document.querySelectorAll(
    ".recipe-content, .product__description"
  );

  const allIcons = document.querySelectorAll(".toggle-icon");

  allContents.forEach((content, index) => {
    if (index === 0) {
      content.classList.add("active");
      content.style.display = "block";
    } else {
      content.classList.remove("active");
      content.style.display = "none";
    }
  });

  allIcons.forEach((icon, index) => {
    if (index === 0) {
      icon.classList.add("rotate");
    } else {
      icon.classList.remove("rotate");
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const dots = document.querySelectorAll(".slider-dot");
  const slides = document.querySelectorAll(".product__media-item");

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {

      slides[index].scrollIntoView({
        behavior: "smooth",
        inline: "center"
      });

      dots.forEach((d) => d.classList.remove("active"));
      dot.classList.add("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {

    const section = document.querySelector(
        "#shopify-section-template--21135604187357__rich_text_KHr7Be .rich-text__text.rte"
    );

    if (!section) return;

    const btn = document.createElement("button");
    btn.textContent = "Read More";
    btn.className = "custom-read-more-btn";

    section.after(btn);

    btn.addEventListener("click", function () {
        section.classList.toggle("expanded");

        this.textContent = section.classList.contains("expanded")
            ? "Read Less"
            : "Read More";
    });

});
